"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _all = require("animations-json/build/all");

var _LottieOutroBase = _interopRequireDefault(require("../../LottieOutroBase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Outro11 = /*#__PURE__*/function (_AnimationBase) {
  _inherits(Outro11, _AnimationBase);

  var _super = _createSuper(Outro11);

  function Outro11(animObj) {
    var _this;

    _classCallCheck(this, Outro11);

    var animationId = animObj.animationId,
        data = animObj.data,
        cdn = animObj.cdn;
    var config = {
      default: {
        colors: ['#ffffff', '#042EDE']
      },
      inputs: ['action_01', 'action_02', 'website', 'disclaimer'],
      width: 1280,
      height: 720,
      fNameToReplace: ['Raleway-Black'],
      inDuration: 1360,
      intermissionDuration: 3000,
      outDuration: 0,
      totalDuration: 4360
    };
    _this = _super.call(this, animObj, data, config);
    var animation = (0, _all.getAnimationJson)(animationId); // set colors

    var luminosity = _this.colorsObj[1].luminosity(); // change disclaimer font color


    var disclaimerColorPattern = new RegExp('"fc":\\[1,1,1]', 'g');
    var disclaimerColor = luminosity > 0.6 ? '"fc":[0,0,0]' : '"fc":[1,1,1]';
    animation = animation.replace(disclaimerColorPattern, disclaimerColor); // change websit font color

    var websiteColorPattern = new RegExp('"fc":\\[1,1,0]', 'g');
    var webSiteColor = luminosity < 0.8 ? '"fc":[0,0,0]' : '"fc":[1,1,1]';
    animation = animation.replace(websiteColorPattern, webSiteColor); // replace font with color 1

    var fontOneColorPattern = new RegExp('"fc":\\[0,1,0]', 'g'); // replace font shade shape to be like the font color

    var fontshade = new RegExp('\\[1,1,1,1]', 'g');
    animation = animation.replace(fontshade, "[".concat(_this.colors[0], "]")); // replace with color 2 f84b74

    var shapeColorPattern = new RegExp('\\[0.015686275437,0.180392161012,0.870588243008,1]', 'g');
    var shapeColorPattern2 = new RegExp('#042ede', 'g');
    animation = animation.replace(fontOneColorPattern, "\"fc\":[".concat(_this.colors[0], "]")).replace(shapeColorPattern, "[".concat(_this.colors[1], "]")).replace(shapeColorPattern2, "".concat(_this.colorsObj[1].rgb())); //  replace website bg color if the secound color is to light

    var websiteShapeColorPattern = new RegExp('\\[1,0,1,1]', 'g');
    var webSiteShapeColor = luminosity < 0.8 ? '[1,1,1,1]' : '[0,0,0,1]';
    animation = animation.replace(websiteShapeColorPattern, webSiteShapeColor);
    animation = _this._setInputs(animation, data, config.inputs);
    animation = _this._setPackshot(animation, data, cdn);
    _this.json = JSON.parse(animation);
    return _this;
  }

  return Outro11;
}(_LottieOutroBase.default);

exports.default = Outro11;